webpackJsonp([183226617504570],{

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/not-good-value.af4d60f7.png";

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeList = __webpack_require__(64);
	
	var _ThemeList2 = _interopRequireDefault(_ThemeList);
	
	var _PageHeader = __webpack_require__(103);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _ThemeNavFooter = __webpack_require__(104);
	
	var _ThemeNavFooter2 = _interopRequireDefault(_ThemeNavFooter);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ShareExhibit = __webpack_require__(85);
	
	var _ShareExhibit2 = _interopRequireDefault(_ShareExhibit);
	
	var _notGoodValue = __webpack_require__(1344);
	
	var _notGoodValue2 = _interopRequireDefault(_notGoodValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  Components
	var Theme3Page = function Theme3Page(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(_PageHeader2.default, {
	        data: data.allThemesJson.edges[2].node,
	        img: _notGoodValue2.default
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Quality of care is not in line with the level of state health spending'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Health care spending in the United States is much greater than in other wealthy countries, but U.S. health outcomes are not better.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#13' },
	                  '13'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Our analysis finds that for every state, health spending exceeds median per capita spending in each of 10 other high-income countries.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#14' },
	                  '14'
	                )
	              ),
	              ' In general, research shows that higher spending in the U.S. is attributable to higher prices.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#15' },
	                  '15'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide section__content__bulleted' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Here are just a few examples of gaps in quality across the U.S.:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Among working-age adults with employer-sponsored insurance, nearly one in three (29%) who were newly diagnosed with lower back pain in 2015 received potentially inappropriate medical imaging. That means the scans these patients received are not associated with improved outcomes when there is no underlying condition; some tests would expose them to unnecessary radiation.',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#16' },
	                    '16'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'One in three adults were not up to date on recommended cancer screenings in 2016. Even in the best-performing state, the shortfall was 24 percent. As many as 40 percent of adults in Idaho, New Mexico, Oklahoma, and Wyoming did not get these screenings.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Even when they have insurance coverage, Americans visit the emergency department (ED) for nonemergency care at high rates. Similarly high rates among Medicare- and employer-insured adults suggest there may be factors other than coverage or age, such as inadequate access to primary care, driving the behavior.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-9-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Note: Lower back pain imaging is measured among newly diagnosed working-age patients ages 18\u201350 with employer-sponsored insurance.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Data: Lower back imaging, 2015 Truven MarketScan Database, analysis by M. Chernew, Harvard University; Cancer screenings, 2016 Behavioral Risk Factor Surveillance System (BRFSS).'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-09',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'section__title' },
	          'Mixed findings on health care spending'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'The average amount Medicare spends on care for each beneficiary has leveled off in recent years across all states.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Spending per enrollee in employer-sponsored insurance plans was nearly flat nationally from 2013 to 2015. However, 18 states saw increases of at least $300 per enrollee during this time, or 5 percent on average \u2014 more than twice the rate of general inflation.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#17' },
	                  '17'
	                )
	              ),
	              ' These data do not include prescription drug costs, which have been rising rapidly in recent years. Both across states and within individual states, there is often no consistent relationship between health care spending by Medicare and by employer-sponsored insurance.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#18' },
	                  '18'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section section__heavy' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'What Can Be Done?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Efforts to control health care costs must be tailored to reflect the unique characteristics of each market.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#19' },
	                  '19'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Greater pricing transparency, coupled with value-based benefit design and payment approaches, could encourage better-informed choices and movement toward higher-value health services and providers.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#20' },
	                  '20'
	                )
	              ),
	              ' Evidence from states and from countries around the world show that health systems with a strong primary care orientation generally achieve better health outcomes at lower cost.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#21' },
	                  '21'
	                )
	              ),
	              ' Making primary care more accessible and patient-centered also can help reduce use of the ED for conditions that could be treated in primary care settings.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#22' },
	                  '22'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__narrow' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'What Are States Doing?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Several states participate in initiatives involving both public and private insurers to foster the transformation of primary care practices into patient-centered medical homes, which can improve patient care and reduce costs.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#23' },
	                  '23'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'State and federal partnerships to integrate care for Medicare and Medicaid beneficiaries aim to reduce hospitalizations and ED use among patients with complex care needs while improving their quality of life.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#24' },
	                  '24'
	                )
	              ),
	              ' In Rhode Island, health plans are required to measure and increase the proportion of health care spending devoted to primary care, without increasing medical costs or premiums.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#25' },
	                  '25'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ThemeNavFooter2.default, { themes: data.allThemesJson.edges }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'ol',
	            { start: '13', style: { counterReset: "item 12" }, className: 'list__notes' },
	            _react2.default.createElement(
	              'li',
	              { id: '13' },
	              'Eric C. Schneider et al., Mirror, Mirror 2017: ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'International Comparison Reflects Flaws and Opportunities for Better U.S. Health Care'
	              ),
	              ' (The Commonwealth Fund, July 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/interactives/2017/july/mirror-mirror/' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/interactives/2017/july/mirror-mirror/'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '14' },
	              'Centers for Medicare and Medicaid Services, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Expenditures by State of Residence'
	              ),
	              ', 1991\u20132014 (CMS, n.d.), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.cms.gov/Research-Statistics-Data-and-Systems/Statistics-Trends-and-Reports/NationalHealthExpendData/NationalHealthAccountsStateHealthAccountsResidence.html' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.cms.gov/Research-Statistics-Data-and-Systems/Statistics-Trends-and-Reports/NationalHealthExpendData/NationalHealthAccountsStateHealthAccountsResidence.html'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '15' },
	              'Austin Frakt and Aaron E. Carroll, \u201CWhy the U.S. Spends So Much More Than Other Nations on Health Care,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'The Upshot'
	              ),
	              ' (blog), ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'New York Times'
	              ),
	              ', Jan. 2, 2018, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.nytimes.com/2018/01/02/upshot/us-health-care-expensive-country-comparison.html' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.nytimes.com/2018/01/02/upshot/us-health-care-expensive-country-comparison.html'
	                )
	              ),
	              '; and Joseph L. Dieleman et al., \u201CFactors Associated with Increases in U.S. Health Care Spending, 1996\u20132013,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA'
	              ),
	              ' 318, no. 17 (Nov. 7, 2017): 1668\u201378, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://jamanetwork.com/journals/jama/article-abstract/2661579' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://jamanetwork.com/journals/jama/article-abstract/2661579'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '16' },
	              'The measure specification excludes patients with underlying conditions for which imaging may be appropriate, to the degree these conditions are captured in claims data; see National Quality Measures Clearinghouse, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Measure Summary: Use of Imaging Studies for Low Back Pain: Percentage of Members with a Primary Diagnosis of Low Back Pain Who Did Not Have an Imaging Study (Plain X-ray, MRI, CT Scan) Within 28 Days of the Diagnosis'
	              ),
	              ' (Agency for Healthcare Research and Quality, 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.qualitymeasures.ahrq.gov/summaries/summary/49748' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.qualitymeasures.ahrq.gov/summaries/summary/49748'
	                )
	              ),
	              ' (site discontinued as of July 17, 2018).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '17' },
	              'Bureau of Labor Statistics, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Consumer Price Index'
	              ),
	              ' (U.S. Department of Labor, 2018), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://data.bls.gov' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://data.bls.gov'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '18' },
	              'Kevin Quealy and Margot Sanger-Katz, \u201CThe Experts Were Wrong About the Best Places for Better and Cheaper Health Care,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'The Upshot'
	              ),
	              ' (blog), ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'New York Times'
	              ),
	              ', Dec. 15, 2015, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.nytimes.com/interactive/2015/12/15/upshot/the-best-places-for-better-cheaper-health-care-arent-what-experts-thought.html' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.nytimes.com/interactive/2015/12/15/upshot/the-best-places-for-better-cheaper-health-care-arent-what-experts-thought.html'
	                )
	              ),
	              '; and Zack Cooper et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'The Price Ain\u2019t Right? Hospital Prices and Health Spending on the Privately Insured'
	              ),
	              ', NBER Working Paper No. 21815 (National Bureau of Economic Research, Dec. 2015), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.nber.org/papers/w21815' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.nber.org/papers/w21815'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '19' },
	              'Dominique Hall and Mark A. Zezza, \u201CMcAllen, Texas: Tailored Solutions to High Spending Are Needed,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'To the Point'
	              ),
	              ' (blog), The Commonwealth Fund, May 5, 2015, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/blog/2015/may/mcallen-texas-health-spending' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/blog/2015/may/mcallen-texas-health-spending'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '20' },
	              'Anna D. Sinaiko, Karen E. Joynt, and Meredith B. Rosenthal, \u201CAssociation Between Viewing Health Care Price Information and Choice of Health Care Facility,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA Internal Medicine'
	              ),
	              ' 176, no. 12 (Dec. 1, 2016): 1868\u201370, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://jamanetwork.com/journals/jamainternalmedicine/fullarticle/2571612' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://jamanetwork.com/journals/jamainternalmedicine/fullarticle/2571612'
	                )
	              ),
	              '; Suzanne F. Delbanco et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Benefit Designs: How They Work'
	              ),
	              ' (Urban Institute and the Catalyst for Payment Reform, Apr. 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.urban.org/research/publication/benefit-designs-how-they-work' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.urban.org/research/publication/benefit-designs-how-they-work'
	                )
	              ),
	              '; Mark B. McClellan et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Payment Reform for Better Value and Medical Innovation: A Vital Direction for Health and Health Care'
	              ),
	              ' (National Academy of Medicine, Mar. 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://nam.edu/wp-content/uploads/2017/03/Payment-Reform-for-Better-Value-and-Medical-Innovation.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://nam.edu/wp-content/uploads/2017/03/Payment-Reform-for-Better-Value-and-Medical-Innovation.pdf'
	                )
	              ),
	              '; and Zirui Song et al., \u201CChanges in Health Care Spending and Quality 4 Years into Global Payment,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'New England Journal of Medicine'
	              ),
	              ' 371, no. 18 (Oct. 30, 2014): 1704\u201314, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.nejm.org/doi/10.1056/NEJMsa1404026' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.nejm.org/doi/10.1056/NEJMsa1404026'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '21' },
	              'Barbara Starfield, Leiyu Shi, and James Macinko, \u201CContribution of Primary Care to Health Systems and Health,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Milbank Quarterly'
	              ),
	              ' 83, no. 3 (2005): 457\u2013502, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/usr_doc/Starfield_Milbank.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/usr_doc/Starfield_Milbank.pdf'
	                )
	              ),
	              '; and Mark W. Friedberg, Peter S. Hussey, and Eric C. Schneider, \u201CPrimary Care: A Critical Review of the Evidence on Quality and Costs of Health Care,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Affairs'
	              ),
	              ' 29, no. 5 (May 2010): 766\u201372, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.healthaffairs.org/doi/abs/10.1377/hlthaff.2010.0025' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.healthaffairs.org/doi/abs/10.1377/hlthaff.2010.0025'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '22' },
	              'Cathy Schoen et al., \u201CAccess, Affordability, and Insurance Complexity Are Often Worse in the United States Compared to Ten Other Countries,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Affairs'
	              ),
	              ' 32, no. 12 (Dec. 2013): 2205\u201315, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/in-the-literature/2013/nov/access-affordability-and-insurance' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/in-the-literature/2013/nov/access-affordability-and-insurance'
	                )
	              ),
	              '; and John Billings, Nina Parikh, and Tod Mijanovich, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Emergency Department Use in New York City: A Substitute for Primary Care?'
	              ),
	              ' (The Commonwealth Fund, March 2000), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/issue-briefs/2000/mar/emergency-department-use-in-new-york-city--a-substitute-for-primary-care' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/issue-briefs/2000/mar/emergency-department-use-in-new-york-city--a-substitute-for-primary-care'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '23' },
	              'Marci Nielsen et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'The Patient-Centered Medical Home\u2019s Impact on Cost and Quality: Annual Review of Evidence, 2014\u20132015'
	              ),
	              ' (Patient-Centered Primary Care Collaborative, Feb. 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.pcpcc.org/resource/patient-centered-medical-homes-impact-cost-and-quality-2014-2015' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.pcpcc.org/resource/patient-centered-medical-homes-impact-cost-and-quality-2014-2015'
	                )
	              ),
	              '; and Amanda R. Markovitz et al., \u201CPatient-Centered Medical Home Implementation and Use of Preventive Services,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA Internal Medicine'
	              ),
	              ' 175, no. 4 (Apr. 2015): 598\u2013606, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://jamanetwork.com/journals/jamainternalmedicine/fullarticle/2110999' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://jamanetwork.com/journals/jamainternalmedicine/fullarticle/2110999'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '24' },
	              'Sarah Klein, Martha Hostetter, and Douglas McCarthy, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'The \u201COne Care\u201D Program at Commonwealth Care Alliance: Partnering with Medicare and Medicaid to Improve Care for Nonelderly Dual Eligibles'
	              ),
	              ' (The Commonwealth Fund, Dec. 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/case-studies/2016/dec/commonwealth-care-alliance' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/case-studies/2016/dec/commonwealth-care-alliance'
	                )
	              ),
	              '; and Alexandra Kruse, Stephanie Gibbs, and Leah Smith, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Advancing Medicare and Medicaid Integration: Key Program Features and Factors Driving State Investment'
	              ),
	              ' (Center for Health Care Strategies, Nov. 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.chcs.org/resource/advancing-medicare-medicaid-integration-key-program-features-factors-driving-state-investment' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.chcs.org/resource/advancing-medicare-medicaid-integration-key-program-features-factors-driving-state-investment'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '25' },
	              'Christopher F. Koller and Dhruv Khullar, \u201CPrimary Care Spending Rate \u2014 A Lever for Encouraging Investment in Primary Care,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'New England Journal of Medicine'
	              ),
	              ' 377, no. 18 (Nov. 2, 2017): 1709\u201311, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.nejm.org/doi/10.1056/NEJMp1709538' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.nejm.org/doi/10.1056/NEJMp1709538'
	                )
	              ),
	              '; and Office of the Health Insurance Commissioner, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Primary Care Spending in Rhode Island: Commercial Health Insurer Compliance'
	              ),
	              ' (State of Rhode Island, Jan. 2014), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.ohic.ri.gov/documents/Primary-Care-Spending-generalprimary-care-Jan-2014.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.ohic.ri.gov/documents/Primary-Care-Spending-generalprimary-care-Jan-2014.pdf'
	                )
	              ),
	              '.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Theme3Page;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-not-good-value-js-3d072e9f0c00049b5fcf.js